// apiServices/auth.js
import axios from 'axios';

const BASE_URL = 'https://api.rezen.in/api/v1/doctors';

const authApi = {
    login: async (email, password) => {
        try {
            const response = await axios.post(`${BASE_URL}/login/`, { email, password });
            return response;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    forgotPassword: async (email) => {
        try {
            const response = await axios.post(`${BASE_URL}/forgot-password/`, { email });
            return response;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    resetPassword: async (email, otp, newPassword) => {
        try {
            const response = await axios.post(`${BASE_URL}/reset-password/`, {
                email,
                otp,
                new_password: newPassword
            });
            return response;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
};

export default authApi;  // Default export